
import EditableField from './EditableField';


export default function FormCanvas({ fields, setFields, preview}) {
  const grouped = fields.reduce((acc, field) => {
    acc[field.section] = acc[field.section] || [];
    acc[field.section].push(field);
    return acc;
  }, {});

  const updateField = (id, updated) => {
    setFields(fields.map(f => f.id === id ? { ...f, ...updated } : f));
  };

  const deleteField = (id) => {
    setFields(fields.filter(f => f.id !== id));
  };

  return (
    <div className="flex-1 overflow-y-auto mt-12">
      {Object.entries(grouped).map(([section, sectionFields]) => (
        <div key={section} className="mb-10">
          <div className="space-y-10">
            {sectionFields.map(field => (
              <EditableField
                key={field.id}
                field={field}
                onUpdate={(updated) => updateField(field.id, updated)}
                onDelete={() => deleteField(field.id)}
                preview={preview}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
